// File: /js/pages/home.js
//
// The « Moniteur » landing (2026-08-12; trimmed to hero · three ways · recent
// cases on AD's 2026-08-15 cuts). The page itself is server-rendered and
// static (the ECG animation is pure CSS); the only JS is the signup hand-off:
// the hero « Créer un compte » CTA carries `data-ui="toggle-modal"` (the
// shared handler opens the existing login/subscribe modal — no new modal
// here); this script additionally switches the modal to its SUBSCRIBE tab.
//
// The Phase-1 CSRF ping demo moved with its panel to /pages/sante/ (sante.js).

document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-home-subscribe]');
  if (triggers.length === 0) return;

  const openSubscribeTab = () => {
    const tab = document.querySelector(
      'a[data-ui="tab-switch"][data-target="#login-tabs-subscribe"]'
    );
    if (tab) tab.click();
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      // The shared data-ui handler (document-level, so it runs AFTER this
      // element-level listener in the same dispatch) opens the modal; switch
      // tab right after the dispatch completes. setTimeout — NOT
      // requestAnimationFrame, whose callbacks are throttled indefinitely in
      // occluded tabs (observed 2026-08-14: rAF scheduled, never fired).
      setTimeout(openSubscribeTab, 0);
    });
  });
});
